import { Loader2 } from 'lucide-react';

export function Spinner({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }): JSX.Element {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
  };

  return (
    <div className="flex justify-center items-center">
      <Loader2
        className={`animate-spin text-brand-500 ${sizeClasses[size]}`}
        role="status"
        aria-label="Loading"
      />
    </div>
  );
}
